import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import Tour from "reactour"
import NextButton from './assets/next';
import Timer from "./timer";


const steps = [
  {
    selector: '',
    content: 'Welcome to the Reconfig Organization design challenge!',
    disableInteraction: true,
  },
  {
    selector: '.card-item',
    content: () => {
      const el = document.querySelector('.card-item');
      const text = el.innerText;
      return `Click on ${text} to proceed`;
    },
    disableInteraction: false,
    autoStep: function() {
      return !!document.querySelector('.card-item.incomming');
    },     
  },
  {
    selector: '.card-item.incomming',
    content: () => {
      const choosen = document.querySelector('.card-item.choosen p').innerText;
      const el = document.querySelector('.card-item.incomming').innerText;
      const elNameOnly = document.querySelector('.card-item.incomming p').innerText;
      
      return `See how ${el}, become green? This means ${choosen} sends frequent information to ${elNameOnly}`;
    },
    disableInteraction: true,
    canGoNext: function() {
      return !!document.querySelector('.card-item.incomming');
    }
  },
  {
    selector: '.group button',
    content: 'You can add new groups to the organization. Click button to proceed',
    autoStep: function() {
      return !!document.querySelector('.group[data-custom="true"] .group-header');
    },    
  },
  {
    selector: '.group[data-custom="true"] .group-header',
    content: 'You can rename the group by double clicking the name',
    disableInteraction: true,
    canGoNext: function() {
      return !!document.querySelector('.group[data-custom="true"] .group-header');
    },
  },    
  {
    selector: '.group[data-custom="true"] .group-header',
    content: 'You can delete groups by selecting the name and clicking the red X that shows up. Please do so now for the group you created',
    disableInteraction: true,
    autoStep: function() {
      return !document.querySelector('.group[data-custom="true"] .group-header');
    },
  },
  {
    selector: '.matrixview svg',
    content: 'The matrix on the right shows all dependencies in the organization. A dependency means a role either provides and/or receives information from another role',
    disableInteraction: true,
    canGoNext: function() {
      return false;
    },
    previousDiabled: function() {
      return true;
    }
  },
  {
    selector: '.matrixview svg',
    content: 'In the matrix, information flows downward, so roles at the top deliver information to roles on the left',
    disableInteraction: true,
  },
  {
    selector: '.matrixrow.selected',
    content: 'Dependencies for the role you selected on the left is highlighted in purple',
    disableInteraction: true,
  },
  {
    selector: '.cell[data-style="same"]',
    content: 'A colored cell means the dependency is between two roles in the same department',
    disableInteraction: true,
  },
  {
    selector: '.cell[data-style="different"]',
    content: 'A black cell means the dependency is between two roles in different departments',
    disableInteraction: true,
  },
  {
    selector: '.coord-load',
    content: 'Your goal is to improve the performance of this organization by minimizing coordination load according to the definition below. Good luck!',
    disableInteraction: true,
  }
];

export default function MyTour({ startDemo, startChallenge, counts, tourSync }) {
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [step, setStep] = useState(0);
  

  const tourRef = useRef();

  // Make the tour's nextStep function available globally for GroupList
  useEffect(() => {
    window.tourNextStep = () => {
      if (tourRef.current && tourRef.current.nextStep) {
        tourRef.current.nextStep();
      }
    };
    return () => {
      window.tourNextStep = undefined;
    };
  }, []);

  const isStepAvailable = (step) => {
    if (!step) {
      return false;
    }
    if (!step.canGoNext) {
      return true;
    } else {
      const cando = step.canGoNext();
      return cando;
    }
    // return selector === '' ? true : !!document.querySelector(selector);
  }
  // const getSteps = () => {
  //   const onScreenSteps = [];
  //   for(const step of steps) {
  //     if (isStepAvailable(step)) {
  //       onScreenSteps.push(step);
  //     } else {
  //       break;
  //     }
  //   }
  //   return onScreenSteps;
  // }
  

  // const mySteps = getSteps();
  const [nextAvailable, setNextAvailable] = useState(true);
  const getCurrentStep = (currentStep) => {
    setNextAvailable(isStepAvailable(steps[currentStep + 1]));
    setStep(currentStep);
  };
  const nextStep = () => {
    if (nextAvailable) {
      if (tourRef.current && tourRef.current.nextStep) {
        tourRef.current.nextStep();
      }
    }
  }

  const currentStp = steps[step];

  useEffect(() => {
    if (currentStp?.autoStep) {
      if (currentStp.autoStep() && !currentStp.gone) {
        currentStp.gone = true;
        setTimeout(() => {
          currentStp.gone = false;
        }, 200);
        tourRef.current && tourRef.current.nextStep();
      }
    }
    // eslint-disable-next-line
  }, [step, currentStp, tourSync]);

  const [mask, setMask] = useState(true);
  const previousDiabled = currentStp.previousDiabled && currentStp.previousDiabled();
  
  useEffect(() => {
    if (!isTourOpen) {
      setStep(0);
      setNextAvailable(true);
    }
  }, [isTourOpen])

  function FinishButton({ onClick }) {
    return (
      <div onClick={onClick} className="finish">
        Finish
      </div>
    );
  }
 

  return (
    <>
      <button className="trigger-tutorial" onClick={() => setIsTourOpen(true)}>Show tutorial</button>
      <div
        className={classNames("tour-trigger", {'open': isTourOpen || !mask})}
      >
        {clicked && mask && <Timer onComplete={() => setMask(false)} />}
        {!clicked && (
          <div className="buttons">
            <button
              className="intro-button intro"
              onClick={() => {
                setIsTourOpen(true);
                setMask(false);
                startDemo();
              }}
            >
              Tutorial {/*<br/> <span>{counts[0]} roles</span>*/}
            </button>
            <button
              className="intro-button go"
              onClick={() => {
                setClicked(true);
                startChallenge();
              }}
            >
              Challenge {/* <br/> <span>{counts[1]} roles</span>*/}
            </button>        
          </div>
        )}
      </div>
      {isTourOpen && <Tour
        ref={tourRef}
        steps={steps}
        isOpen={isTourOpen}
        highlightedMaskClassName="tour-mask"
        closeWithMask={false}
        showNavigation={false}
        getCurrentStep={getCurrentStep}
        nextStep={nextStep}
        nextButton={NextButton({disabled: !nextAvailable})}
        prevButton={NextButton({reverse: true, disabled: previousDiabled})}
        lastStepNextButton={FinishButton({onClick: () => setIsTourOpen(false)})}
        onRequestClose={() => setIsTourOpen(false)}
        className="tour-helper"
        update={step.toString()}
        disableFocusLock={true}
        disableKeyboardNavigation={true}
      />}
    </>
  );
}
